var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bet-radar-widget" }, [
    _c("div", {
      ref: "betradarScriptContainer",
      attrs: { id: "betradarScriptContainer", "ng-init": "loadScript()" }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "betradar-widget-container-desktop",
        class: _vm.brandKey,
        attrs: { id: "sr-widget" }
      },
      [
        _c("div", { staticClass: "score" }),
        _vm._v(" "),
        _c("div", { staticClass: "lmt" })
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "betradar-widget-container-mobile",
      class: _vm.brandKey,
      attrs: { id: "sr-widget" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dc696e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc696e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/betRadarWidgetv2.vue
// module id = null
// module chunks = 